import { ConnectedUsers } from './ConnectedUsers';

export default ConnectedUsers;
